import AdGroups from './AdGroups'
import LensMetrics from './Metrics'
import TimeSeries from './TimeSeriesRequests'
import Lens from './LensRequests'
import LensReport from './ReportRequests'
import LensPreset from './PresetRequests'
import LensFolder from './FolderRequests'
import Tags from './TagsRequests'

export default {
  Lens,
  LensReport,
  LensPreset,
  AdGroups,
  LensMetrics,
  TimeSeries,
  LensFolder,
  Tags
}
